<template>
  <div @keyup.enter="$emit('siguiente')">
    <TemplateCambios>
      <div class="panel">
        <div class="cabecera">
          Realizado
        </div>

        <div v-if="genero == 'M'" class="texto">
          Tu {{ campo }} ha sido modificado correctamente
        </div>
        <div v-if="genero == 'F'" class="texto">
          Tu {{ campo }} ha sido modificada correctamente
        </div>

        <button
          type="submit"
          class="pure-button boton"
          @click="$emit('siguiente')"
        >
          Ok
        </button>
      </div>
    </TemplateCambios>
  </div>
</template>

<script>
export default {
  props: {
    campo: { type: String, required: true },
    genero: { type: String, required: false, default: "M" }
  }
};
</script>

<style lang="scss" scoped></style>
